import React from 'react'

//Styles
import Styles from "./komisi-pembeli.module.scss";

//Components - atoms
import InputCommision from 'pages/dashboard/e-reporting/forms/components/reuseables/input-commision/InputCommision'
import TitleInputWithName from 'pages/dashboard/e-reporting/forms/components/reuseables/title-input-with-name/TitleInputWithName'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya'
import TitlePerSection from 'pages/dashboard/e-reporting/forms/components/reuseables/title-per-section'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Utils
import { classModuleGrouping } from "utils/classModuleGrouping";

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function KomisiPembeli() {
  const { form, isAprroval } = useFormState();
  const { setCurrentStep, setForm, handlePrevState } = useFormMethod();
  const classHandler = (strngs) => classModuleGrouping(Styles, strngs);

  const handleNext = () => {
    handlePrevState()
    setCurrentStep(STEPS.biayaReferralPembeli)
  }

  function handleChange(event) {
    const myString = event.target.value || '';
    const regex = /^[0-9.\s]+$/;

    const isMatch = regex.test(myString);
    if (isMatch) {
      return myString
    };

    const len = myString.length || 0;

    if (len <= 1) return 0;
    return (len ? myString.slice(len - 1) : 0)
  }

  const commisionHandler = (name, value) => {
    const newForm = { ...form };
    if (value > 100) return;

    if (name == 'komisi_pembeli_utama') {
      newForm.komisi_pembeli_utama.value = value;
      newForm.komisi_pembeli_asisten.value = 100 - value;
    } else {
      newForm.komisi_pembeli_asisten.value = value;
      newForm.komisi_pembeli_utama.value = 100 - value;
    }

    setForm(newForm)
  }

  //make usememo with this name isShowBtnNext
  const isShowBtnNext = React.useMemo(() => {
    if (!form.komisi_pembeli_utama.value || !form.komisi_pembeli_utama.value) {
      return false
    }
    return true
  })

  return (
    <div className={classHandler('wrapper')}>
      <div className={classHandler('box')}>
        <TitlePerSection buyer className={classHandler('mb-[16px]')} />
        <div className={classHandler('comission-wrapper')}>
          <div className={"mb-[8px]"}>
            <TitleInputWithName
              text={`Berapa persen yang didapatkan`}
              name={form.marketing_pembeli.value.full_name}
              className={"mb-[16px]"}
            />
          </div>

          <div className={"mb-[40px]"}>
            <InputCommision
              max={100}
              disabled={true}
              value={form.komisi_pembeli_utama.value || ''}
              className={classHandler('mb-[40px]')}
              onChange={(e) => commisionHandler('komisi_pembeli_utama', handleChange(e))}
            />
          </div>

          <div className={Styles['mb-[8px]']}>
            <TitleInputWithName
              text={`Berapa persen yang didapatkan`}
              name={form.asisten_pembeli.value.full_name}
              className={"mb-[8px]"}
            />
          </div>
          <InputCommision
            disabled={true}
            max={100}
            value={form.komisi_pembeli_asisten.value || ''}
            onChange={(e) => commisionHandler('komisi_pembeli_asisten', handleChange(e))}
          />
          <BoxFlex>
            <>
              <ButtonSebelumnya />
              {isShowBtnNext && <ButtonSelanjutnya onClick={handleNext} />}
            </>
          </BoxFlex>
        </div>
      </div>
    </div>
  )
}

export default KomisiPembeli